import { fetchUserStatement } from '../../apiCalls/urls/urlFunction';
import * as actionTypes from '../actionTypes';

export function onFetchUserStatement() {
    return async (dispatch) => {
        let statementResponse = await fetchUserStatement();
        if (statementResponse?.status) {
            dispatch(updateStatementReducer(statementResponse))
        }
        else {
            console.error(statementResponse.message)
        }
    }
}

export const updateStatementReducer = (payload) => {
    return {
        type: actionTypes.UPDATE_USER_STATEMENT_REDUCER,
        payload: payload
    };
}
